define('modules/editor/behaviours/localizable_property_group',['require','exports','module','i18n'],function(require,exports,module){
  "use strict";
  var i18n = require("i18n");
  /**
  Model Behaviour
  Allows a PropertyGroup model to have some of his properties
  localized. This means that the attribute content must be
  translated, and stored again upon the first render.

  This is used extensively to localize the page templates.

  Usage:

  Define the properties to be translated in a localizableAttrs
  array, in the model definition:

  localizableAttrs: ["content", "label"]
  **/
  var LocalizablePropertyGroup = {
    mixed: function(klass, proto){
      proto.initialize = _.wrap(proto.initialize || _.identity(), function(init){
        this.__localizableDone = false;
        init.apply(this, _.rest(arguments));
      });
      proto.applyStyles = _.wrap(proto.applyStyles,
        this._localizableApplyStyles);
    },
    _localizableApplyStyles: function(originalFunc){
      var $virtualElement, originalContent, localizedContent;
      if(!this.__localizableDone){
        _.each(this.localizableAttrs || [], function(attr){
          originalContent = this.get(attr).trim();
          $virtualElement = $("<div />");
          $virtualElement.html(originalContent);
          //translate it
          $virtualElement.i18n();
          $virtualElement.find("[data-i18n]")
              .removeAttr("data-i18n");
          localizedContent = $virtualElement.html().trim();

          //if the content is different, clean up i18n and save it
          if(originalContent !== localizedContent){
            this.set(attr, localizedContent, {silent:true});
          }
          $virtualElement.empty();
        }, this);
        //flag as already localized
        this.__localizableDone = true;
      }

      originalFunc.apply(this, _.rest(arguments));
    }
  };

  module.exports = LocalizablePropertyGroup;
});
